import { createSelector } from 'reselect'

const getChangePasswordError = ({ passwordReset }) => passwordReset.changePasswordError
const getUpdatePasswordError = ({ passwordReset }) => passwordReset.updatePasswordError
const getUpdatingPassword = ({ passwordReset }) => passwordReset.updatingPassword

const passwordResetSelectors = {
  getChangePasswordError: createSelector([getChangePasswordError], (changePasswordError) => {
    return changePasswordError
  }),
  getUpdatePasswordError: createSelector([getUpdatePasswordError], (updatePasswordError) => {
    return updatePasswordError
  }),
  getUpdatingPassword: createSelector([getUpdatingPassword], (updatingPassword) => {
    return updatingPassword
  }),
}

export default passwordResetSelectors
